export default {
  club_name: 'SF-appen',
  club_name_short: 'sandefjord',
  stadium_name: '',
  staging_url: 'https://sandefjord.api.fangroup.io',
  prod_url: 'https://sandefjord.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/sandefjord',
  club_logo: '/assets/teams/sandefjord.png',
  app_name: 'sandefjord',
  websale_name: 'sandefjord',
  ntb_team_id: 10061,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'NOK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'sandefjord',
  monolithEnabled: false,
};
